module.exports = __webpack_public_path__ + "static/media/dad-playhouse.453ce053.png";